/*
 * File: FabSpacer.js
 * Project: mp-mobile-app
 *
 * Created by Cole on 12/19/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates a spacing div large enough to push content above it completely above the standard Floating Action Button.
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const styles = () => ({
  fabSpacer: {
    height: 72
  }
});

const FabSpacer = ({ classes }) => <div className={classes.fabSpacer} />;

FabSpacer.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(FabSpacer);
